import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';


const SelectSearch = ({ ListValeurs, ListValeursEntreprise, OrigineCRMContent, LanguageSelected, OrigineCRMInfo, AddingOrigineCRMInfo, InputsErrors }) => {
  const { t } = useTranslation();

  const [isOpenVille, setIsOpenVille] = useState(false);
  const [isOpenEvent, setIsOpenEvent] = useState(false);
  const [isOpenAction, setIsOpenAction] = useState(false);
  const [searchTermVille, setSearchTermVille] = useState('');
  const [searchTermEvent, setSearchTermEvent] = useState('');
  const [searchTermAction, setSearchTermAction] = useState('');


  const toggleDropdownVille = () => {
    setIsOpenVille(!isOpenVille);
  };

  const toggleDropdownEvent = () => {
    setIsOpenEvent(!isOpenEvent);
  };

  const toggleDropdownAction = () => {
    setIsOpenAction(!isOpenAction);
  };

  const handleChange = (selectedOption, name) => {
    const event = {
      target: {
        name,
        value: selectedOption ? selectedOption.value : null
      }
    };
    AddingOrigineCRMInfo(event);
    if (name === 'ville') setIsOpenVille(false)
    if (name === 'Evenement') setIsOpenEvent(false)
    if (name === 'Action') setIsOpenAction(false)

  };

  const handleInputChangeVille = (e) => {
    setSearchTermVille(e.target.value.toLowerCase());
  };

  const handleInputChangeEvent = (e) => {
    setSearchTermEvent(e.target.value.toLowerCase());
  };

  const handleInputChangeAction = (e) => {
    setSearchTermAction(e.target.value.toLowerCase());
  };

  const villeOptions = ListValeurs
    .filter(valeur => valeur.type === 'Ville' && valeur.value.toLowerCase().includes(searchTermVille))
    .map(valeur => ({
      value: valeur.id,
      label: valeur.value
    }));

  const eventOptions = ListValeursEntreprise
    .filter(valeur => valeur.type === 'event' && valeur.value.toLowerCase().includes(searchTermEvent))
    .map(valeur => ({
      value: valeur.id,
      label: valeur.value
    }));

  const actionOptions = ListValeursEntreprise
    .filter(valeur => valeur.type === 'action' && valeur.value.toLowerCase().includes(searchTermAction))
    .map(valeur => ({
      value: valeur.id,
      label: valeur.value
    }));

  const findValue = (id, name) => {
    if (name === 'ville') {
      const value = villeOptions?.find(valeur => valeur.value === parseInt(id))
      return value?.label || null

    }
    else if (name === 'Action') {
      const value = actionOptions?.find(valeur => valeur.value === parseInt(id))
      console.log(value)
      return value?.label || null

    } else {
      const value = eventOptions?.find(valeur => valeur.value == parseInt(id))
      return value?.label || null

    }

  }

  return (
    <div className='grid  gap-5 w-full'>
      <div className='relative'>
        <div
          id="dropdown-a-ville"
          className="relative block w-full placeholder-sm px-3  py-2 sections border border-transparent rounded placeholder-gray-111 text-black    sm:text-sm" >
          <a onClick={toggleDropdownVille}  className="mr-2 text-theme">{OrigineCRMInfo.ville ? findValue(OrigineCRMInfo.ville, 'ville') : t('Ville')}</a>
          {OrigineCRMInfo.ville &&

            <a href="#" onClick={() => handleChange(null, 'ville')} >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={`lucide ${LanguageSelected == 'ar' ? 'left-10' : 'right-10 '} rounded-full p-1 div-sections cursor-pointer top-4 text-theme absolute lucide-x`}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
            </a>
          }
          <svg onClick={toggleDropdownVille} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={`lucide  ${LanguageSelected == 'ar' ? 'left-3 ' : 'right-3 '} top-4 text-theme absolute lucide-chevron-down`}><path d="m6 9 6 6 6-6" /></svg>
        </div>
        <div id="dropdown-menu-ville" className={`absolute z-50 w-full h-72 overflow-y-auto right-0 mt-2 rounded-md shadow-lg sections  ring-opacity-5 p-1 space-y-1 ${isOpenVille ? '' : 'hidden'}`}>
          <input
            id="search-input-ville"
            className="appearance-none block w-full placeholder-sm px-3 py-2 div-sections border border-transparent rounded placeholder-gray-111 text-black focus:outline-none  sm:text-sm"
            type="text"
            placeholder={t("Search ...")}
            value={searchTermVille}
            onChange={handleInputChangeVille}
            autoComplete="off"
          />
          {villeOptions && villeOptions.map(item => (
            <a
              href="#"
              onClick={() => handleChange(item, 'ville')}
              className="block px-4 py-2 text-theme  cursor-pointer rounded-md"
              key={item.value}
            >
              {item.label}
            </a>
          ))}
          {InputsErrors.hasOwnProperty('Ville') && <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.Ville}</span></p>}
        </div>
      </div>

      <div className='relative'>
        <div
          id="dropdown-a-event"
          className="relative block w-full placeholder-sm px-3 py-2 sections border border-transparent rounded placeholder-gray-111     sm:text-sm"
        >
          <a onClick={toggleDropdownEvent} className="mr-2 text-theme">{OrigineCRMInfo.Evenement ? findValue(OrigineCRMInfo.Evenement, 'event') : t('Evenement')}</a>
          {OrigineCRMInfo.Evenement &&
            <a href="#" onClick={() => handleChange(null, 'Evenement')} >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={`lucide ${LanguageSelected == 'ar' ? 'left-10' : 'right-10 '} rounded-full p-1 div-sections cursor-pointer top-4 text-theme absolute lucide-x`}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
            </a>
          }

          <svg onClick={toggleDropdownEvent} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={`lucide  ${LanguageSelected == 'ar' ? 'left-3 ' : 'right-3 '} top-4 text-theme absolute lucide-chevron-down`}><path d="m6 9 6 6 6-6" /></svg>

        </div>
        <div id="dropdown-menu-event" className={`absolute z-50 w-full h-72 overflow-y-auto right-0 mt-2 rounded-md shadow-lg sections  p-1 space-y-1 ${isOpenEvent ? '' : 'hidden'}`}>
          <input
            id="search-input-event"
            className="appearance-none block w-full placeholder-sm px-3 py-2 div-sections border border-transparent rounded placeholder-gray-111 text-black focus:outline-none  sm:text-sm"
            type="text"
            placeholder={t("Search ...")}
            value={searchTermEvent}
            onChange={handleInputChangeEvent}
            autoComplete="off"
          />
          {eventOptions && eventOptions.map(item => (
            <a
              href="#"
              onClick={() => handleChange(item, 'Evenement')}
              className="block px-4 py-2 text-theme  cursor-pointer rounded-md"
              key={item.value}
            >
              {item.label}
            </a>
          ))}
          {InputsErrors.hasOwnProperty('Evenement') && <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.Evenement}</span></p>}
        </div>
      </div>

      <div className='relative'>
        <a
          id="dropdown-a-action"
          className="relative block w-full placeholder-sm px-3 py-2 sections border border-transparent rounded placeholder-gray-111 text-black   sm:text-sm"
        >
          <a onClick={toggleDropdownAction} className="mr-2 text-theme" >{OrigineCRMInfo?.Action ? findValue(OrigineCRMInfo.Action, 'Action') : t('Action')}</a>
          {OrigineCRMInfo.Action &&

            <a href="#" onClick={() => handleChange(null, 'Action')} >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={`lucide ${LanguageSelected == 'ar' ? 'left-10' : 'right-10 '} rounded-full p-1 div-sections cursor-pointer top-4 text-theme absolute lucide-x`}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
            </a>
          }
          <svg onClick={toggleDropdownAction} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={`lucide  ${LanguageSelected == 'ar' ? 'left-3 ' : 'right-3 '} top-4 text-theme absolute lucide-chevron-down`}><path d="m6 9 6 6 6-6" /></svg>

        </a>
        <div id="dropdown-menu-action" className={`absolute z-50 w-full h-72 overflow-y-auto right-0 mt-2 rounded-md  sections border-none p-1 space-y-1 ${isOpenAction ? '' : 'hidden'}`}>
          <input
            id="search-input-action"
            className=" div-sections z-50 w-full placeholder-sm px-3 py-2 div-sections border-none rounded placeholder-gray-111 text-black   sm:text-sm"
            type="text"
            placeholder={t("Search ...")}
            value={searchTermAction}
            onChange={handleInputChangeAction}
            autoComplete="off"
          />
          {actionOptions && actionOptions.map(item => (
            <a
              href="#"
              onClick={() => handleChange(item, 'Action')}
              className="block px-4 py-2 text-theme  cursor-pointer rounded-md"
              key={item.value}
            >
              {item.label}
            </a>
          ))}
          {InputsErrors.hasOwnProperty('Action') && <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.Action}</span></p>}
        </div>
      </div>
    </div>
  );
};

export default SelectSearch;
